import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

export const MinusIcon = ({
  height = 2,
  width = 16,
  fillColor,
  isFilled = false,
  ...rest
}: MinusIconProps & SvgProps) => {
  const { colors } = useTheme()
  const fill = fillColor || colors.iconDefault

  if (isFilled) {
    return (
      <Svg width={width} height={width} viewBox='0 0 24 24' fill='none' testID={tID('MinusIcon')} {...rest}>
        <Path
          fill={fill}
          d='M15.25,12.75 L8.75,12.75 C8.34,12.75 8,12.41 8,12 C8,11.59 8.34,11.25 8.75,11.25 L15.25,11.25 C15.66,11.25 16,11.59 16,12 C16,12.41 15.66,12.75 15.25,12.75 M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2'
        />
      </Svg>
    )
  }

  return (
    <Svg width={width} height={height} viewBox='0 0 16 2' fill='none' testID={tID('MinusIcon')} {...rest}>
      <Path d='M1 1H15' stroke={fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </Svg>
  )
}

export type MinusIconProps = {
  height?: number
  width?: number
  fillColor?: string
  isFilled?: boolean
}
